<template>
    <v-container fluid class="pa-0">
        <!-- Header -->
        <v-row class="">
            <v-col cols="12">
                <div class="dashboard-header">
                    <v-icon large color="white" class="mr-3">mdi-view-dashboard</v-icon>
                    <div>
                        <h1 class="text-h4 font-weight-bold white--text">Dashboard de Inventario TI</h1>
                        <p class="text-subtitle-1 white--text ma-0">
                            Resumen general de equipos, accesorios y licencias</p>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <!-- Equipos Totales -->
            <v-col cols="12" sm="6" md="3" lg="3">
                <v-card class="stat-card gradient-blue" dark elevation="8">
                    <v-card-text class="pa-3">
                        <div class="d-flex justify-space-between align-center">
                            <div class="white--text">
                                <p class="text-overline mb-1" style="line-height: 1rem;">Total Equipos</p>
                                <h2 class="text-h4 font-weight-bold">{{ totalEquipment }}</h2>
                                <p class="text-caption mt-1">Registrados en el sistema</p>
                            </div>
                            <v-icon size="64" class="stat-icon">mdi-laptop</v-icon>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- Equipos Propios -->
            <v-col cols="12" sm="6" md="3" lg="2" v-for="tenency in GroupTenencyEquipments" :key="tenency.Title">
                <v-card class="stat-card gradient-blue" dark elevation="8">
                    <v-card-text class="pa-3">
                        <div class="d-flex justify-space-between align-center">
                            <div class="white--text">
                                <p class="text-overline mb-1" style="line-height: 1rem;">{{ tenency.Title }}</p>
                                <h2 class="text-h4  font-weight-bold">{{ tenency.Value }}
                                </h2>
                                <p class="text-caption mt-1">
                                    {{Math.round((tenency.Value / GroupTenencyEquipments.reduce((sum, item) => sum
                                        + item.Value, 0)) * 100)}}
                                    % del total</p>
                            </div>
                            <v-icon size="64" class="stat-icon">mdi-check-circle</v-icon>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- Accesorios -->
            <v-col cols="12" sm="6" md="3" lg="3">
                <v-card class="stat-card gradient-blue" dark elevation="8">
                    <v-card-text class="pa-3">
                        <div class="d-flex justify-space-between align-center">
                            <div class="white--text">
                                <p class="text-overline mb-1" style="line-height: 1rem;">Total Accesorios</p>
                                <h2 class="text-h4 font-weight-bold">{{ totalAccessories }}</h2>
                                <p class="text-caption mt-1">Registrados</p>
                            </div>
                            <v-icon size="64" class="stat-icon">mdi-mouse</v-icon>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Gráficas Principales -->
        <v-row>
            <!-- Distribución de Equipos por Tipo de Tenencia -->
            <!-- <v-col cols="12" md="6">
                <v-card elevation="4" class="chart-card">
                    <v-card-title class="card-title-custom">
                        <v-icon class="mr-2" color="primary">mdi-chart-donut</v-icon>
                        Distribución de Equipos
                    </v-card-title>
                    <v-card-text class="pa-6">
                        <canvas ref="tenureChart"></canvas>
                    </v-card-text>
                </v-card>
            </v-col> -->

            <v-col cols="12" md="4">
                <!-- Estado General -->
                <v-card elevation="4" class="chart-card">
                    <v-card-title class="card-title-custom">
                        <v-icon class="mr-2" color="primary">mdi-clipboard-check</v-icon>
                        Resumen de los Equipos
                    </v-card-title>
                    <v-card-text>
                        <div v-for="status in GroupStatusEquipments" :key="status.label" class="mb-3">
                            <div class="d-flex justify-space-between mb-1">
                                <span class="font-weight-medium">{{ status.Title }}</span>
                                <span class="font-weight-bold">{{ status.Value }}</span>
                            </div>
                            <v-progress-linear
                                :value="(status.Value / GroupStatusEquipments.reduce((a, b) => a + b.Value, 0)) * 100"
                                :color="status.Abreviature == '1' ? 'green' : status.Abreviature == '2' ? 'yellow' : status.Abreviature == '3' ? 'red' : 'blue'"
                                height="8" rounded></v-progress-linear>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- Licencias de Software -->
            <v-col cols="12" md="8">
                <v-card elevation="4" class="chart-card">
                    <v-card-title class="card-title-custom">
                        <v-icon class="mr-2" color="primary">mdi-license</v-icon>
                        Licencias de Software
                    </v-card-title>
                    <v-card-text class="pa-0">
                        <v-simple-table class="pa-0">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">Software</th>
                                        <th class="text-center">Total</th>
                                        <th class="text-center">Vigentes</th>
                                        <th class="text-center">Expiradas</th>
                                        <th class="text-center">Estado</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="license in GroupStatusLicences" :key="license.Title">
                                        <td class="font-weight-medium">{{ license.Title }}</td>
                                        <td class="text-center">{{ license.Value }}</td>
                                        <td class="text-center">
                                            <v-chip small color="success" text-color="white">
                                                {{ license.Activas }}
                                            </v-chip>
                                        </td>
                                        <td class="text-center">
                                            <v-chip small color="error" text-color="white">
                                                {{ license.Expiradas }}
                                            </v-chip>
                                        </td>
                                        <td class="text-center">
                                            <v-progress-linear :value="(license.Activas / license.Value) * 100"
                                                :color="(license.Activas / license.Value) * 100 > 70 ? 'success' : 'warning'"
                                                height="20" rounded>
                                                <strong>
                                                    {{ Math.round((license.Activas / license.Value) * 100) }}%</strong>
                                            </v-progress-linear>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <!-- Equipos por Tipo -->
            <v-col cols="12" lg="12">
                <v-card elevation="4" class="chart-card">
                    <v-card-title class="card-title-custom">
                        <v-icon class="mr-2" color="primary">mdi-chart-bar</v-icon>
                        Tipos de Equipos
                    </v-card-title>
                    <v-card-text class="pa-6">
                        <canvas ref="equipmentTypeChart" height="300"></canvas>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Registro Mensual de Equipos -->
        <v-row>
            <v-col cols="12">
                <v-card elevation="4" class="chart-card">
                    <v-card-title class="card-title-custom">
                        <v-icon class="mr-2" color="primary">mdi-chart-line</v-icon>
                        Historial de Registro de Equipos
                    </v-card-title>
                    <v-card-text class="pa-6">
                        <canvas ref="monthlyChart" height="300"></canvas>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Áreas con Equipos Asignados -->
        <v-row>
            <v-col cols="12" md="12">
                <v-card elevation="4" class="chart-card">
                    <v-card-title class="card-title-custom">
                        <v-icon class="mr-2" color="primary">mdi-office-building</v-icon>
                        Equipos por Área
                    </v-card-title>
                    <v-card-text class="pa-6">
                        <canvas ref="areaChart"></canvas>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import _TicEquipment from "@/services/InformationTechnology/TicEquipmentService";

import {
    Chart,
    DoughnutController,
    BarController,
    LineController,
    ArcElement,
    BarElement,
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    Title,
    Tooltip,
    Legend
} from 'chart.js';

// Registrar componentes de Chart.js
Chart.register(
    DoughnutController,
    BarController,
    LineController,
    ArcElement,
    BarElement,
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    Title,
    Tooltip,
    Legend
);

export default {
    components: {},
    data() {
        return {
            // Dashboard Data - Datos de prueba
            totalEquipment: 0,
            ownedEquipment: 5,
            rentedEquipment: 10,
            totalAccessories: 0,
            GroupCategoryEquipments: [],
            GroupMonthEquipments: [],
            GroupStatusLicences: [],
            GroupTenencyEquipments: [],
            GroupStatusEquipments: [],
            GroupAssignsAreaEquipments: [],
            // Licencias de software
            // softwareLicenses: [
            //     { name: 'Microsoft Office 365', total: 85, active: 78, expired: 7 },
            //     { name: 'Windows 10/11 Pro', total: 120, active: 115, expired: 5 },
            //     { name: 'Antivirus Kaspersky', total: 95, active: 88, expired: 7 },
            //     { name: 'Adobe Creative Cloud', total: 25, active: 22, expired: 3 },
            //     { name: 'AutoCAD', total: 15, active: 13, expired: 2 }
            // ],
            // Estadísticas adicionales

            // Estado de equipos
            equipmentStatus: [
                { label: 'Disponible', count: 23, color: 'success' },
                { label: 'Asignado', count: 122, color: 'primary' },
                { label: 'Mantenimiento', count: 8, color: 'warning' },
                { label: 'Fuera de Servicio', count: 5, color: 'error' }
            ],
            // Charts instances
            tenureChartInstance: null,
            equipmentTypeChartInstance: null,
            monthlyChartInstance: null,
            areaChartInstance: null
        };
    },
    computed: {
        ownedPercentage() {
            return Math.round((this.ownedEquipment / this.totalEquipment) * 100);
        },
        rentedPercentage() {
            return Math.round((this.rentedEquipment / this.totalEquipment) * 100);
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initData();
            // this.initializeCharts();
        });
    },
    beforeDestroy() {
        // Destruir instancias de gráficos
        if (this.tenureChartInstance) this.tenureChartInstance.destroy();
        if (this.equipmentTypeChartInstance) this.equipmentTypeChartInstance.destroy();
        if (this.monthlyChartInstance) this.monthlyChartInstance.destroy();
        if (this.areaChartInstance) this.areaChartInstance.destroy();
    },
    methods: {
        formatearMesAnio(fecha) {
            const [anio, mes] = fecha.split("-");
            const mesesAbrev = [
                "Ene", "Feb", "Mar", "Abr", "May", "Jun",
                "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"
            ];

            return `${mesesAbrev[parseInt(mes) - 1]} ${anio}`;
        },
        generarColores() {
            const r = Math.floor(Math.random() * 256);
            const g = Math.floor(Math.random() * 256);
            const b = Math.floor(Math.random() * 256);
            const fondo = `rgb(${r}, ${g}, ${b}, .1)`;
            const factor = 0.75; // 75% del original = más oscuro
            const borde = `rgb(${Math.floor(r * factor)}, ${Math.floor(g * factor)}, ${Math.floor(b * factor)})`;
            return { fondo, borde };
        },
        capitalize(text) {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        },
        initData() {
            const colors = ['gradient-green', 'gradient-purple', 'gradient-orange', 'gradient-red'];
            const requestID = this.$fun.getUserID();
            _TicEquipment.statistics({}, requestID).then((result) => {
                // console.log(result.data)
                if (result.status == 200) {
                    this.totalEquipment = result.data.TotalEquipment;
                    this.totalAccessories = result.data.TotalAccessories;
                    this.GroupCategoryEquipments = result.data.GroupCategoryEquipments;
                    this.GroupMonthEquipments = result.data.GroupMonthEquipments;
                    this.GroupStatusLicences = result.data.GroupStatusLicences;
                    this.GroupStatusEquipments = result.data.GroupStatusEquipments;
                    this.GroupAssignsAreaEquipments = result.data.GroupAssignsAreaEquipments;
                    this.GroupTenencyEquipments = result.data.GroupTenencyEquipments.map((item, index) => {
                        return {
                            Title: item.Title,
                            Value: item.Value,
                            Color: index < colors.length ? colors[index] : ''
                        }
                    });

                    this.initializeCharts();
                }
            });
        },
        save(item) {
            if (!item.TinSppedyProcessor) item.TinSppedyProcessor = 0;
            if (!item.TinHDD) item.TinHDD = 0;
            if (!item.TinPrice) item.TinPrice = 0;
            if (!item.TinMemoryMB) item.TinMemoryMB = 0;
            if (this.validationForm());
            item.save();
        },
        validationForm() {
            return true;
        },
        initializeCharts() {
            this.createTenureChart();
            this.createEquipmentTypeChart();
            this.createMonthlyChart();
            this.createAreaChart();
        },
        createTenureChart() {
            const ctx = this.$refs.tenureChart;
            if (!ctx) return;

            this.tenureChartInstance = new Chart(ctx, {
                type: 'doughnut',
                data: {
                    labels: this.GroupTenencyEquipments.map(item => item.Title),
                    // labels: ['Equipos Propios', 'Equipos Alquilados'],
                    datasets: [{
                        data: this.GroupTenencyEquipments.map(item => item.Value),
                        // data: [this.ownedEquipment, this.rentedEquipment],
                        backgroundColor: [
                            'rgba(86, 171, 47, 0.8)',
                            'rgba(79, 172, 254, 0.8)',
                            'rgba(107, 52, 59, 0.8)'
                        ],
                        borderColor: [
                            'rgba(86, 171, 47, 1)',
                            'rgba(79, 172, 254, 1)',
                            'rgba(107, 52, 59, 1)'
                        ],
                        borderWidth: 2
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: true,
                    plugins: {
                        legend: {
                            position: 'bottom',
                            labels: {
                                padding: 20,
                                font: {
                                    size: 13
                                }
                            }
                        },
                        tooltip: {
                            callbacks: {
                                label: function (context) {
                                    const label = context.label || '';
                                    const value = context.parsed || 0;
                                    const total = context.dataset.data.reduce((a, b) => a + b, 0);
                                    const percentage = Math.round((value / total) * 100);
                                    return `${label}: ${value} (${percentage}%)`;
                                }
                            }
                        }
                    }
                }
            });
        },
        createEquipmentTypeChart() {
            const ctx = this.$refs.equipmentTypeChart;
            if (!ctx) return;

            this.equipmentTypeChartInstance = new Chart(ctx, {
                type: 'bar',
                data: {
                    // labels: ['Laptops', 'Desktops', 'Monitores', 'Impresoras', 'Tablets', 'Servidores'],
                    labels: this.GroupCategoryEquipments.map(item => this.capitalize(item.Title)),
                    datasets: [{
                        label: 'Cantidad',
                        // data: [52, 38, 85, 18, 12, 8],
                        data: this.GroupCategoryEquipments.map(item => item.Value),
                        backgroundColor: [
                            'rgba(33, 150, 243, 0.7)',
                            'rgba(156, 39, 176, 0.7)',
                            'rgba(255, 193, 7, 0.7)',
                            'rgba(76, 175, 80, 0.7)',
                            'rgba(255, 87, 34, 0.7)',
                            'rgba(96, 125, 139, 0.7)',
                            'rgba(60, 100, 13, 0.7)',
                            'rgba(110, 45, 130, 0.7)',
                            'rgba(89, 180, 78, 0.7)',
                        ],
                        borderColor: [
                            'rgba(33, 150, 243, 1)',
                            'rgba(156, 39, 176, 1)',
                            'rgba(255, 193, 7, 1)',
                            'rgba(76, 175, 80, 1)',
                            'rgba(255, 87, 34, 1)',
                            'rgba(96, 125, 139, 1)',
                            'rgba(60, 100, 13, 1)',
                            'rgba(110, 45, 130, 1)',
                            'rgba(89, 180, 78, 1)',
                        ],
                        borderWidth: 2
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: false
                        }
                    },
                    scales: {
                        y: {
                            beginAtZero: true,
                            ticks: {
                                stepSize: 10
                            }
                        }
                    }
                }
            });
        },
        createMonthlyChart() {
            const ctx = this.$refs.monthlyChart;
            if (!ctx) return;
            const monthLabels = [...new Set(this.GroupMonthEquipments.map(x => (x.Title)))];
            const tenencias = [...new Set(this.GroupMonthEquipments.map(x => x.Tenencia))];

            const datasets = tenencias.map(tenency => {
                const { fondo, borde } = this.generarColores()
                const values = monthLabels.map(mes => {
                    return this.GroupMonthEquipments.filter(x => x.Title == mes && x.Tenencia == tenency).reduce((sum, item) => sum + item.Value, 0);
                });

                return {
                    label: `${tenency}`,
                    data: values,
                    borderColor: borde,
                    backgroundColor: fondo,
                    tension: 0.4,
                    fill: true,
                    borderWidth: 3,
                    pointRadius: 5,
                    pointHoverRadius: 7
                };
            });

            // console.log({ tenencias, monthLabels })
            this.monthlyChartInstance = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: monthLabels.map(x => this.formatearMesAnio(x)),
                    // labels: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                    datasets: datasets,
                    // datasets: [
                    //     {
                    //         label: 'Equipos Propios',
                    //         data: [5, 8, 12, 7, 10, 15, 9, 11, 14, 8, 6, 10],
                    //         borderColor: 'rgba(76, 175, 80, 1)',
                    //         backgroundColor: 'rgba(76, 175, 80, 0.1)',
                    //         tension: 0.4,
                    //         fill: true,
                    //         borderWidth: 3,
                    //         pointRadius: 5,
                    //         pointHoverRadius: 7
                    //     },
                    //     {
                    //         label: 'Equipos Alquilados',
                    //         data: [3, 5, 4, 6, 8, 5, 7, 6, 4, 5, 3, 4],
                    //         borderColor: 'rgba(255, 152, 0, 1)',
                    //         backgroundColor: 'rgba(255, 152, 0, 0.1)',
                    //         tension: 0.4,
                    //         fill: true,
                    //         borderWidth: 3,
                    //         pointRadius: 5,
                    //         pointHoverRadius: 7
                    //     }
                    // ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            position: 'top',
                            labels: {
                                padding: 20,
                                font: {
                                    size: 13
                                }
                            }
                        }
                    },
                    scales: {
                        y: {
                            beginAtZero: true,
                            ticks: {
                                stepSize: 5
                            }
                        }
                    }
                }
            });
        },
        createAreaChart() {
            const ctx = this.$refs.areaChart;
            if (!ctx) return;

            this.areaChartInstance = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: this.GroupAssignsAreaEquipments.map(x => x.Title),
                    // labels: ['Sistemas', 'Contabilidad', 'Ventas', 'Marketing', 'RRHH', 'Operaciones', 'Gerencia'],
                    datasets: [{
                        label: 'Equipos Asignados',
                        data: this.GroupAssignsAreaEquipments.map(x => x.Value),
                        // data: [28, 18, 22, 15, 12, 35, 8],
                        backgroundColor: 'rgba(33, 150, 243, 0.7)',
                        borderColor: 'rgba(33, 150, 243, 1)',
                        borderWidth: 2
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: true,
                    indexAxis: 'y',
                    plugins: {
                        legend: {
                            display: false
                        }
                    },
                    scales: {
                        x: {
                            beginAtZero: true,
                            ticks: {
                                stepSize: 5
                            }
                        }
                    }
                }
            });
        }
    }
};
</script>

<style scoped>
/* Dashboard Header */
.dashboard-header {
    display: flex;
    align-items: center;
    padding: 16px;
    /* background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%); */
    background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Stat Cards con Gradientes */
.stat-card {
    border-radius: 16px !important;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    overflow: hidden;
}

.stat-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2) !important;
}

.gradient-blue {
    background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
    /* background: linear-gradient(135deg, #526bdb 0%, #738dff 100%) !important; */
}

.gradient-green {
    background: linear-gradient(135deg, #56ab2f 0%, #a8e063 100%) !important;
}

.gradient-orange {
    background: linear-gradient(135deg, #f093fb 0%, #6b343b 100%) !important;
}

.gradient-purple {
    background: linear-gradient(135deg, #8dc0ff 0%, #63a9ff 100%) !important;
}

.gradient-light {
    background: linear-gradient(135deg, #e4e5e5 0%, #b7d3e3 100%) !important;
}

.stat-icon {
    opacity: 0.7;
}

/* Chart Cards */
.chart-card {
    border-radius: 12px !important;
    transition: box-shadow 0.3s ease;
}

.chart-card:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15) !important;
}

.card-title-custom {
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    font-weight: 600;
    font-size: 1.1rem;
    border-bottom: 2px solid #e0e0e0;
}

/* Responsive adjustments */
@media (max-width: 960px) {
    .dashboard-header h1 {
        font-size: 1.5rem !important;
    }

    .stat-card {
        /* margin-bottom: 16px; */
    }
}

/* Table styling */
::v-deep .v-data-table {
    border-radius: 8px;
}

::v-deep .v-data-table thead th {
    background-color: #f5f5f5 !important;
    font-weight: 600 !important;
}

/* Progress bars */
::v-deep .v-progress-linear {
    border-radius: 8px;
}

/* List items */
::v-deep .v-list-item {
    border-bottom: 1px solid #f0f0f0;
}

::v-deep .v-list-item:last-child {
    border-bottom: none;
}

/* Animations */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.v-card {
    animation: fadeIn 0.5s ease-out;
}
</style>
